<template>
  <div>
    <base-box title="查詢條件">
      <v-container grid-list-md>
        <v-layout row
                  wrap
                  class="form">
          <v-flex sm6>
            <sub-header><template v-slot:title>要保人</template>
            </sub-header>
            <v-text-field placeholder="請輸入"
                          v-model="oCusName"
                          outline></v-text-field>
          </v-flex>
          <v-flex sm6>
            <sub-header><template v-slot:title>被保險人</template>
            </sub-header>
            <v-text-field placeholder="請輸入"
                          v-model="iCusName"
                          outline></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row
                  wrap
                  class="form">
          <v-flex sm6>
            <sub-header><template v-slot:title>主約商品名稱</template>
            </sub-header>
            <v-text-field placeholder="請輸入"
                          v-model="proName"
                          outline></v-text-field>
          </v-flex>
          <v-flex sm6>
            <sub-header><template v-slot:title>要保書處理進度</template>
            </sub-header>
            <div id="polStateID"
                 class="menu-has-id">
              <v-select v-model="polState"
                        :items="admCodeList"
                        item-text="text"
                        item-value="value"
                        label="請選擇"
                        hide-no-data
                        :menu-props="{ closeOnContentClick: true, auto: true }"
                        outline>
                <v-list-tile slot="prepend-item"
                             @click="polState = null">
                  <v-list-tile-title>請選擇</v-list-tile-title>
                </v-list-tile>
              </v-select>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row
                  wrap
                  class="form">
          <v-flex sm6>
            <sub-header><template v-slot:title>最後異動日期</template>
            </sub-header>
            <v-layout row
                      wrap
                      class="form">
              <v-flex xs6>
                <v-menu v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startDate"
                                  readonly
                                  placeholder="起"
                                  outline
                                  v-on="on"
                                  clearable
                                  class="date-picker-input">
                      <template v-slot:append>
                        <v-fade-transition leave-absolute>
                          <img width="24"
                               height="24"
                               @click="menu = true"
                               src="@/assets/icon_calendar.svg"
                               alt="calendar">
                        </v-fade-transition>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="startDate"
                                 no-title
                                 :header-date-format="headerFormatDates"
                                 :max="endDate"
                                 @input="menu = false">
                                </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-menu v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="endDate"
                                  append-icon="event"
                                  readonly
                                  placeholder="迄"
                                  outline
                                  clearable
                                  class="date-picker-input"
                                  v-on="on">
                      <template v-slot:append>
                        <v-fade-transition leave-absolute>
                          <img width="24"
                               height="24"
                               @click="menu1 = true"
                               src="@/assets/icon_calendar.svg"
                               alt="calendar">
                        </v-fade-transition>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="endDate"
                                 no-title
                                 :header-date-format="headerFormatDates"
                                 :min="startDate"
                                 :max="new Date().toISOString().substr(0, 10)"
                                 @input="menu1 = false">
                                </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm6>
            <sub-header><template v-slot:title>案件類型</template>
            </sub-header>
            <div id="polStateID"
                 class="menu-has-id">
              <v-select v-model="polInsureType"
                        :items="polTypeList"
                        item-text="codeName"
                        item-value="codeValue"
                        label="請選擇"
                        hide-no-data
                        :menu-props="{ closeOnContentClick: true, auto: true }"
                        outline>
                <v-list-tile slot="prepend-item"
                             @click="polState = null">
                  <v-list-tile-title>請選擇</v-list-tile-title>
                </v-list-tile>
              </v-select>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </base-box>
    <base-btn>
      <btn-lg-default @click="clearAll(true)"
                      class="float-left">全部清除</btn-lg-default>
      <btn-lg-secondary @click="queryDataCheck">查詢</btn-lg-secondary>
      <btn-lg-primary @click="policyToggleHandler">新增要保書</btn-lg-primary>
    </base-btn>
    <base-container has-title
                    title="查詢結果"
                    v-if="showSearchResult"
                    style="padding-top:10px">
      <div style="color:blue;text-align: right;">註：各保險公司跳轉後填簽期限請依本頁左側『表單下載\跳轉後填簽期限』公告為準，逾期需重新簽單。</div>
      <v-data-table :headers="headers"
                    :items="searchResult"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[5,10,15,25,50] "
                    rows-per-page-text="顯示資料筆數"
                    no-data-text="查無資料可顯示"
                    class="elevation-1">
        <template v-slot:headers="props">
          <th v-for="header in props.headers"
              :key="header.value"
              :class="['column', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'sortable active' : '']"
              @click="headerHandler(header.value)">
              <v-icon v-if="sortItems.includes(header.value)"
                    small>arrow_upward</v-icon>
            <span v-html="header.text"></span>
          </th>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.createDt }}</td>
            <td class="text-xs-center">{{ props.item.modifyDt }}</td>
            <td class="text-xs-center">{{ props.item.polInsureTypeName }}</td>
            <td class="text-xs-center">
               <div v-if="props.item.insureNo !== null">{{ props.item.insureNo }}</div>
              {{props.item.insAcceptNo}}</td>
            <td class="text-xs-center">{{ props.item.oCusName }}</td>
            <td class="text-xs-center">{{ props.item.iCusName }}</td>
            <td class="text-xs-center">{{ props.item.proName }}</td>
            <td class="text-xs-center" >
              <a v-if="props.item.polState =='R' || props.item.preSignState == 'R'"
                  @click="stateMsg(props.item.returnDesc)">
               <div v-html="props.item.polStateName"> </div>
              </a>
              <div v-else v-html="props.item.polStateName"></div>
            </td>
            <td class="text-xs-center" >{{ (props.item.polState =='N' || props.item.polState == 'O'|| props.item.polState == 'B') ? '' : props.item.insAcceptdt}}</td>

            <td class="text-xs-center">
              <base-edit-btn
                         :actions="btnActions(props.item)"
                         @action-preview="previewHandler(props.item)"
                         @action-edit="editHandler(props.item)"
                         @action-copy="copyHandler(props.item)"
                         @action-delete="deleteHandler(props.item)"
                         @action-consentDownload="consentDownloadHandler(props.item)"
                         @action-jumpApp="jumpAppHandler(props.item)"
                         @action-reSent="reSentHandler(props.item)"
                         @action-interview="interviewHandler(props.item)"
                         @action-moneyLaund="moneyLaundHandler(props.item)"
                         @action-writSendDate="writSendDateHandler(props.item)"
                         @action-writtenDownload="writtenDownloadHandler(props.item)"
                         @action-writtenReSend="writtenReSendHandler(props.item)"

                         ></base-edit-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-container>

    <!-- 選擇要保書案件類型 -->
    <choose-pol-type  v-if="showPolType" @close="closeChoosePolTypeDialog" @copy-process="copyProcess" :edit-comp-code="choosePolTypeCompCode" :edit-ins-type="choosePolTypeInsType" ></choose-pol-type>

    <!-- 檢核資料重送 -->
    <base-dialog-adm :show="showCheckItem"
                    title="檢核總表"
                    width="1000"
                    btn-close-text="取消"
                    btn-confirm-text="送審"
                    btn-event-text="暫存"
                    :btn-confirm="true"
                    :btn-event="true"
                    @close="closeCheckItemDialog"
                    @save="checkItemPropAudit"
                    @event="checkItemPropTempSave"
                    >
      <check-item  ref="checkItemDialogRef"
                   :ins-file-limit="insFileLimit"
                   :init-file-item="checkItemFileList"
                   :init-data="checkItemData"
                   :fin-status="true"
                   @file-picker="filePickerLog"
                   @audit="checkItemAudit"
                   @temp-save="checkItemTempSave"
                   @upload-file="onUpload"
                   @delete-file="onDelete"
                   ></check-item>
    </base-dialog-adm>

    <!-- 轉跳凱壽前檢視 -->
    <preview-Pdf-Result v-if="showPreViewPDF"
            :item="preViewPdfItem"
            :pol-insure-type ="polInsureType"
            @close="closePreViewPDFResultDialog"
            ></preview-Pdf-Result>

    <!-- 回填電訪結果 -->
    <interview-result v-if="showInterview"
            :item="interviewItem"
            @close="closeInterviewResultDialog"
            @commit="commitInterviewResult"
            ></interview-result>

  <!-- 回填寄件日期 -->
  <writ-send-date v-if="showWritSendDate"
            :item="writSendItem"
            @close="closewWritSendDateDialog"
            @commit="commitwWritSendDate"
            ></writ-send-date>

    <!-- 洗防資料重送 -->
    <base-dialog-adm ref="refAgentFilesDialog"
                    :show="showMoneyLaund"
                    title="洗防資料重送"
                    width="1000"
                    btn-close-text="取消"
                    btn-confirm-text="送審"
                    :btn-confirm="true"
                    :btn-confirm-disabled="!moneyLaundConfirmFlag"
                    @close="closeMoneyLaundDialog"
                    @save="moneyLaundAudit"
                    >
        <step-agent-files ref="refAgentfiles"
                          v-if="showMoneyLaund"
                          @go-top="agentFilesGoTop"
                          @set-money-laund-confirm-flag="setMoneyLaundConfirmFlag"
                          :money-laund-mode="true"
                          :prop-trans-code="showMoneyLaundTransCode"
                          :pol-insure-type="showMoneyLaundPolInsureType"
        >

        </step-agent-files>
    </base-dialog-adm>

    <!-- 簽名功能頁面 -->
    <proposal-dialog-signature v-if="showProposalDialogSignature"
                               @close="proposalDialogSignatureClose"
                               :source-flag-to-go="sourceFlagToGo"
                               :trans-code="currentItemTransCode"></proposal-dialog-signature>
  </div>
</template>
<script>
import CheckItem from '@/components/Ins/Policy/CheckItem'
import { datepickerFormat } from '@/mixin'
import StepAgentFiles from '@/views/Proposal/Steps/StepAgentFiles.vue'
import format from 'date-fns/format'
import { filter, groupBy, indexOf } from 'lodash'
import { createNamespacedHelpers } from 'vuex'
import ProposalDialogSignature from './ProposalDialogSignature.vue'
import ChoosePolType from './searchPage/ChoosePolType'
import InterviewResult from './searchPage/InterviewResult'
import PreviewPdfResult from './searchPage/PreviewPdfResult'
import WritSendDate from './searchPage/WritSendDate'
const { mapActions } = createNamespacedHelpers('ins')
const { mapActions: commonMapActions } = createNamespacedHelpers('common')
export default {
  name: 'proposal',
  mixins: [datepickerFormat],
  props: {
     aTransCode: {
      type: String
    }
  },
  components: {
    InterviewResult,
    PreviewPdfResult,
    WritSendDate,
    ChoosePolType,
    CheckItem,
    StepAgentFiles,
    ProposalDialogSignature
  },
  data () {
    return {
      transCode:'',
      isAppDev: false,
      carryYn: '', // 是否為攜出裝置
      admCodeList: [], // 要保書處理進度下拉
      polTypeList: [], //案件類型下拉
      searchResult: [],
      iCusName: null,
      oCusName: null,
      polState: null,
      polInsureType: null, // 案件類型
      proName: null,
      startDate: null,
      endDate: null,
      menu: false,
      menu1: false,
      showSearchResult: false, // 查詢結果 區域是否顯示
      preViewPdfItem: {}, // 檢視預覽PDF所需資料
      userAccessLog: {
        transCode: '',
        actionMsg: '',
        progClassName: '',
        methodName: '',
        sysType: '',
        stepCode: ''
      },
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      headers: [
        { text: '建立日期', align: 'center', value: 'createDt', sortable: false,  width: '4%' },
        { text: '最後異動日期', align: 'center', value: 'modifyDt', sortable: true,  width: '4%' },
        { text: '類型', align: 'center', value: 'polInsureTypeName', sortable: true,  width: '4%' },
        { text: '行投/遠距序號<br/>保單受理編號', align: 'center', value: 'transCode', sortable: true, width: '10%' },
        { text: '要保人', align: 'center', value: 'oCusName', sortable: true,  width: '4%' },
        { text: '被保人', align: 'center', value: 'iCusName', sortable: true,  width: '4%' },
        { text: '主約商品名稱', align: 'center', value: 'proName', sortable: true,  width: '4%' },
        { text: '要保書處理進度', align: 'center', value: 'polStateName', sortable: true,  width: '4%' },
        { text: '保險公司進件完成日', align: 'center', value: 'insAcceptdt', sortable: true,  width: '4%' },
        { text: '編輯', align: 'center', value: '', width: '4%' },
      ],
      pagination: {
        sortBy: 'createDt',
        descending: true,
        rowsPerPage: 15
      },
      sortItems: ['createDt', 'modifyDt','transCode','oCusName','iCusName','proName','polStateName','insAcceptdt'],
      interviewItem: {}, // 回填電訪結果 傳入物件
      writSendItem: {}, // 回填寄件日期 傳入物件
      showInterview: false, // 展開回填電訪結果視窗
      showPreViewPDF: false, //展開凱壽PDF後預覽視窗
      showCheckItem: false, //展開檢核資料重送
      showPolType: false, //展開選擇要保書案件類型
      choosePolTypeCompCode: '', //展開選擇要保書案件類型, 對應的 保險公司代碼 , add by SCR #89560
      choosePolTypeInsType: '',//展開選擇要保書案件類型, 對應的 案件類型 , add by SCR #89560
      keepCopyItem: null, //保留複製物件項目, add by SCR #89560
      showWritSendDate: false, //展開回填寄件日期
      checkItemData: null, // 檢核項目 來源資料(列表)
      checkItemFileList: null, // 檢核項目 來源資料(檔案)
      showMoneyLaund: false, // 展開洗防資料重送
      showMoneyLaundTransCode: '', // 洗防資料重送的transCode,
      showMoneyLaundPolInsureType: '', // 洗防資料重送的案件類型
      moneyLaundConfirmFlag: false,
      showProposalDialogSignature: false,
      sourceFlagToGo: '', //『進入來源』: O=要保書查詢頁「跳轉保險公司」按鈕進入 , S=要保書查詢頁「編輯」按鈕進入
      currentItemTransCode: '' ,
    }
  },
  filters: {
  },
  watch: {
  },
  computed: {
    channelCode () { // 通路類型
      let param = this.$store.getters['common/systemParam']({
          parameterType: 'ADM',
          parameterCode: ['CHANNEL_CODE'],
          toObject: true
      })
      return param.CHANNEL_CODE.parameterValue
    },
    compCode () { // 系統公司代碼
      let param = this.$store.getters['common/systemParam']({
          parameterType: 'ADM',
          parameterCode: ['COMP_CODE'],
          toObject: true
      })
      return param.COMP_CODE.parameterValue
    },
    insParameters () {
      return this.$store.getters['common/systemParam']({
        parameterType: 'INS',
        toObject: true
      })
    },
    insFileLimit () { // 可上傳檔案數量(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['FILE_LIMIT']
      limit = parseInt(limit)
      return limit
    },

  },
  methods: {
    ...mapActions([
      'fetchInsPolicies',
      'fetchTransCode',
      'fetchCusInfoCopy',
      'fetchInsPoliciesPolf',
      'delFile',
      'postUpdFileBase64',
      'fetchInsPoliciesRecords',
      'postInterViewResult',
      'postWritSendDate',
      'postReSendWritten',
      'fetchCheckItem',
      'postCheckItem',
      'fetchJumpApp'
    ]),
    ...commonMapActions([
      'fetchAllSystemParam',
      'fetchAllAdmCodeDetail',
      'checkUiVer',
      "fetchAdmUsers"
    ]),
    init () {
      this.$api.get('/adm/com/coded').then(r => {
        let resData = r.data
        this.admCodeList.push({ value: '', text: '全部' })
        this.polTypeList.push({ codeValue: '', codeName: '全部' })
        for (let i = 0; i < resData.length; i++) {
          if ( (resData[i].codeType === 'POL_STATE' || resData[i].codeType === 'AML_PASS_STATE' ||
          resData[i].codeType === 'ELEC_CALL_STATE' || resData[i].codeType === 'PRE_SIGN_STATE' || resData[i].codeType === 'WRIT_SEND_STATE') &&
          resData[i].codeValue !== 'U') {
            this.admCodeList.push({
              value: resData[i].codeType+resData[i].codeValue, // CODE_TYPE + CODE_VALUE
              text: resData[i].codeName
            })
          }
        }
        let polTypeArray = this.$store.getters['common/admCodeDetail']({
          codeType: 'POL_INSURE_TYPE'
        })
        polTypeArray.forEach( elenemt=> {
          this.polTypeList.push({
            codeValue: elenemt.codeValue,
            codeName: elenemt.codeName
          })
        })

      })
       const aTransCode = localStorage.getItem('aTransCode')
       if(aTransCode) {
        this.transCode = aTransCode
        this.queryData(false)
      } else {
         this.queryDataCheck ()
      }

    },
    policyToggleHandler () {
      this.checkUiVer().then((r) => {
        if (!r) {
          // 版號有異動
          this.$alert("版號有異動，重新載入!", (yn) => {
            window.location.reload();
          });
        } else {
          this.$alert("依PIMS個資外部顧問建議，蒐集填入客戶個資前需先取得客戶同意<br>若您採空白建檔(非採按放大鏡引用者)，請先填寫客戶姓名及手機號碼<br>請通知客戶收到簡訊請點同意。", (yn) => {
            if(!yn){
              this.choosePolTypeCompCode = ''
              this.choosePolTypeInsType = ''
              this.showPolType = true
            }
          });
        }
      })

    },
    agentFilesGoTop () {
      this.$refs['refAgentFilesDialog'].scrollTop()
    },
    btnActions (item) { // 按鈕事件
      const { polState, preSignState, elecCallState, amlPassState, eddPassState, writSendState, polInsureType } = item
      let actions = {}
      actions['preview'] = 'N' !== polState // 檢視
      actions['edit'] = indexOf(['N', 'S'], polState) >= 0 //編輯
      actions['copy'] = true // 複製
      actions['delete'] = indexOf(['N', 'S', 'O'], polState) >= 0 //刪除
      actions['consentDownload'] = indexOf(['N','O', 'P', 'S', 'U', 'A'], polState) >= 0 && indexOf(['M'], polInsureType) >= 0 //同意書下載
      actions['jumpApp'] = indexOf(['O'], polState) >= 0 //跳轉APP
      actions['reSent'] = indexOf(['U'], polState) >= 0 && indexOf(['R'], preSignState) >= 0 // 檢核資料重送
      actions['interview'] = indexOf(['U'], polState) >= 0 && indexOf(['P'], elecCallState) >= 0 //回填電訪結果
      actions['moneyLaund'] = indexOf(['U'], polState) >= 0 && indexOf(['P'], amlPassState) >= 0 // 洗防資料重送
      //fix: SCR #89564 , 將 「EDD表單下載」  功能移除!
      //actions['eddDownload'] = indexOf(['U', 'P'], polState) >= 0 && indexOf(['A'], eddPassState) >= 0 // EDD表單下載
      actions['writSendDate'] = indexOf(['U','S'], polState) >= 0 && indexOf(['P'], writSendState) >= 0 && indexOf(['R'], polInsureType) >= 0 // 回填寄件日期
      actions['writtenDownload'] = indexOf(['A', 'U', 'P','S'], polState) >= 0 && indexOf(['A', 'P'], writSendState) >= 0 && indexOf(['R'], polInsureType) >= 0 // 書面分析下載
      actions['writtenReSend'] = indexOf(['A', 'U', 'P','S'], polState) >= 0 && indexOf(['N'], writSendState) >= 0 && indexOf(['R'], polInsureType) >= 0 // 重寄書面分析

      // for test
      if (process.env.NODE_ENV === 'development') {
        actions['preview'] = true
        actions['edit'] =  true
        actions['copy'] =  true
        actions['delete'] = true
        actions['consentDownload'] = true
        actions['jumpApp'] = true
        actions['reSent'] = true
        actions['interview'] = true
        actions['moneyLaund'] = true
        //fix: SCR #89564 , 將 「EDD表單下載」  功能移除!
        //actions['eddDownload'] = true
        actions['writSendDate'] = true
        actions['writtenDownload'] = true
        actions['writtenReSend'] = true
      }
      return actions
    },
    copyProcess(param){// 複製 - fix: SCR #89560 , 加上複製案件功能可選擇原保司或其他保司
      const item = this.keepCopyItem
      item.compCode =param.compCode
      item.polInsureType = param.polInsureType
      this.fetchTransCode().then(r => {
        if (r.data) {
          let transCode = r.data
          //用要複製的'來源transCode' 將資料複製到'新產出的transCode'的各個表
          // copyTransCode => 來源transCode
          // transCode => 新產出的transCode
          // fix: SCR #89560 , 修正複製後，挑選新的保險公司代碼參數的替換問題
          this.fetchCusInfoCopy( { copyTransCode: item.transCode, transCode: transCode, compCode: item.compCode, polInsureType: item.polInsureType } ).then(r=> {
            //fix: SCR #84277 , 再複製過程中針對 去發查客戶資料，在有資料之情況下，更新客戶資料(含財務資料)!
            const rtData = r.data
            if(rtData){
              if(rtData.returnCode === '00'){
                const params = { notReloadAction: true,
                      enterpoint: 'proposal' ,
                      compCode: item.compCode,
                      transCode: transCode,  //新產出的transCode
                      isPreview: false,
                      polInsureType: item.polInsureType
                    }
                this.$router.replace({ name: item.polInsureType === "M" ? 'proposalMain' : 'proposalRemote', params }).catch(err => {})
              }else{
                this.$alert(rtData.returnMsg)
              }
            }else{
              this.$alert('API 呼叫異常!')
            }
          })
        }
      })

      this.insStepHandler({ progClassName: 'proposal_copy', methodName: '要保書複製', stepCode: '', transCode: item.transCode, polInsureType: item.polInsureType })

    },
    copyHandler (item) { // 複製
      const msg = '是否確定複製？'
      this.keepCopyItem = null
      this.$confirm(
        msg
      ).then(yn => {
        if (yn) {
         //fix: SCR #89560 , 加上複製案件功能可選擇原保司或其他保司
         this.choosePolTypeCompCode = item.compCode
         this.choosePolTypeInsType = item.polInsureType
         this.showPolType = true
         this.keepCopyItem = item
        }
      })
    },
    editHandler (item) { // 編輯
      this.currentItemTransCode = item.transCode
      const vm = this
      if (item.polState === 'N') { // 帶入至要保書建置-要保人頁籤
        if (item.polInsureType  === 'R') { // 遠距投保
          this.fetchAdmUsers().then((r) => {
            let admUser = r.data;
            if (admUser.remoteEduYn !== "Y") {
              this.$alert('欲進行遠距投保，請先完成遠距投保教育訓練！')
            } else {
              const params = { notReloadAction: true,
                          enterpoint: 'proposalRemote' ,
                          compCode: item.compCode,
                          transCode: item.transCode,
                          isPreview: false,
                          polInsureType: item.polInsureType
                          }
              this.$router.push({ name:  'proposalRemote', params }).catch(err => {})
            }
          });
        } else { // 行動投保
          const params = { notReloadAction: true,
                          enterpoint: 'proposal'  ,
                          compCode: item.compCode,
                          transCode: item.transCode,
                          isPreview: false,
                          polInsureType: item.polInsureType
                          }
          this.$router.push({ name: 'proposalMain', params }).catch(err => {})
        }
      }
      if (item.polState === 'S') { // 帶入至帶入至要保書建置-保經表單頁籤
        let {signoffDt} = item
        let todayf = format(new Date(), 'yyyy/MM/dd') //今天日期
        let insAcceptDt = format(new Date(item.insAcceptDt), 'yyyy/MM/dd') //insAcceptDt的日期
        if (item.polInsureType  === 'R' && item.writSendState === null && item.insAcceptDt && todayf > insAcceptDt) { // 若『案件類型』='R'且SRV_4.WRIT_SEND_STATE為空值 且 目前日期>SRV_4.INS_ACCEPT_DT (取日期部份)
          this.$alert('您填寫書面分析報告日期已非客戶視訊完成日，本案依規已逾期，請重新和客戶約訪再進件。')
          return false
        }else{
          if (item.polInsureType !== 'R' && !signoffDt){ // 判斷SRV_4.SIGNOFF_DT是否為空值的流程處理 ,空值則進入客戶簽名頁
            //fix: Issue #83809 , 判斷SRV_4.SIGNOFF_DT是否為空值的流程處理
             //fix: Issue #83809 , SRV_4.SIGNOFF_DT 若為空值 ，顯示訊息
            this.$alert('目前狀態為您可能忘了請保戶於 iPAD簽署「個資同意書及書面分析」２文件，請先帶 iPAD約客戶簽署完成上述文件，才能後續由您填寫客戶「防制洗錢風險評級表」(可用公司電腦填)，以完成整個行動投保流程。').then(()=>{
              vm.sourceFlagToGo = 'S'
              vm.showProposalDialogSignature = true //開啟，簽名功能獨立畫面
            })
          }else{//若非空值,走原本流程
            const params = { notReloadAction: true,
                            enterpoint: item.polInsureType === "M" ? 'proposal' :'proposalRemote'  ,
                            compCode: item.compCode,
                            transCode: item.transCode,
                            routerPage: item.polInsureType === "M"  ? 'INS_S9' : 'REMOTE_S7',
                            propKey: {
                              transCode: item.transCode
                            },
                            isPreview: false,
                            polInsureType: item.polInsureType
                          }
            this.$router.replace({ name: item.polInsureType === "M" ? 'proposalMain' : 'proposalRemote', params }).catch(err => {})
          }
        }
      }
      this.insStepHandler({ progClassName: 'proposal_edit', methodName: '要保書修改',stepCode: '', transCode: item.transCode, polInsureType: item.polInsureType })
    },
    previewHandler (item) { // 檢視
      if (item.polState === 'O') { //進入同編輯畫面
        const params = { notReloadAction: true,
                         enterpoint: 'proposal' ,
                         compCode: item.compCode,
                         transCode: item.transCode,
                         polInsureType: item.polInsureType,
                         isPreview:true
                        }
        this.$router.push({ name: item.polInsureType === "M" ? 'proposalMain' : 'proposalRemote', params }).catch(err => {})
      }
      if ( item.polState !== 'O') {
        this.showPreViewPDFHandler(item) // 進入完成凱壽APP後檢視畫面
      }
      this.insStepHandler({ progClassName: 'proposal_preview', methodName: '要保書檢視', stepCode: '', transCode: item.transCode, polInsureType: item.polInsureType })
    },
    deleteHandler (item) { // 刪除
      this.$confirm('是否確認刪除此筆資料？').then(yn => {
        if (yn) {
          this.$api
            .delete('/ins/common/insPolicies/proposal', {
              params: { transCode: item.transCode }
            })
            .then(r => {
              this.clearAll(false)
              this.$alert('刪除成功')
              this.searchResult = []
              this.queryData(false)
              this.insStepHandler({ progClassName: 'proposal_del', methodName: '要保書刪除', stepCode: '', transCode: item.transCode, polInsureType: item.polInsureType })
            })
        }
      })
    },
    jumpAppHandler (item) { // 轉跳APP 改為 跳轉保險公司
      let {signoffDt} = item
      this.currentItemTransCode = item.transCode
      const vm = this
      if(signoffDt || item.polInsureType  === 'R'){  //fix: Issue #83809 , 判斷SRV_4.SIGNOFF_DT是否為空值的流程處理
        //若非空值,走原本流程
        this.insStepHandler({ progClassName: 'proposal_jumpApp', methodName: '要保書轉跳APP', stepCode: '', transCode: item.transCode, polInsureType: item.polInsureType})
        this.fetchJumpApp({
          transCode: item.transCode,
          compCode: item.compCode,
          insAcceptDt: item.insAcceptDt, // Timestamp 傳去後端轉String處裡
          insAcceptNo: item.insAcceptNo
        }).then(r => {
          const { erorrMsg,url } = r.data
          if ( erorrMsg != null) { // 進入時間是否超過12小時或已跨日，顯示錯誤訊息
            this.$alert(erorrMsg)
          } else {
            // window.location.replace(url)
            window.open(url, '_blank') // 跳轉凱壽APP
          }
        })
      }else{//空值則進入客戶簽名頁
        this.$alert('保戶尚未於書面分析及個資同意書簽名，若您為訪客前先協助客戶至保險公司頁面或APP預填，可暫忽略本訊息，但記得正式面訪客戶時務必請客戶於 iPAD先簽「個資同意書及書面分析」２文件，以免投保後需再次回頭請客戶簽署。').then(()=>{
          vm.sourceFlagToGo = 'O'
          vm.showProposalDialogSignature = true //開啟，簽名功能獨立畫面
        })
      }
    },
    consentDownloadHandler (item) { //同意書下載
      let transCode = item.transCode
      let insureNo = item.insureNo
      const idStr = 'downloadConsentPdf_Link'
      let url = this.$api.defaults.baseURL +
      '/ins/common/insPolicies/downloadConsentPdf?transCode='+ transCode
      // 因為對於 Safari 瀏覽器，由於它不支持 download 屬性，改為在新的分頁中打開檔案
      if (this.$isSafari) {
        window.open(url, "_blank");
      } else {
        let link = null
        link = document.getElementById(idStr)
        if (!link) {
          link = document.createElement('a')
          link.id = idStr
          link.style.display = 'none'
          link.target = '_blank'
          document.body.appendChild(link)
        }
        link.href = url
        let fileName = '行動投保確認同意書_' + insureNo + '.pdf'
        link.setAttribute('download', fileName)
        this.startLoading()
        link.click()

        setTimeout(() => {
          this.endLoading()
          this.queryData(false)
        }, 1000)
      }
      this.insStepHandler({ progClassName: 'proposal_consentDownload', methodName: '同意書下載', stepCode: '', transCode: item.transCode})
    },
    reSentHandler (item) { // 檢核資料重送 視窗開啟與取得資料
      this.fetchCheckItem({ transCode: item.transCode, isPreview: false, fromSearch: true }).then(r => {
        if (r.data.errorMsg != null ) { // 不通過要顯示訊息
            this.$alert(r.data.errorMsg )
          } else {
            this.checkItemData = r.data
            this.fetchInsPoliciesPolf({ transCode: item.transCode, fileGroup: ['VALIDATE'] }).then(r => {
              this.checkItemFileList = r.data
              this.showCheckItem = true
              this.transCode = item.transCode
            })
          }
      })
      .catch ( (e) => {
        console.log(e)
      })
      this.insStepHandler({ progClassName: 'proposal_reSent', methodName: '檢核資料重送', stepCode: '', transCode: item.transCode})
    },
    moneyLaundHandler (item) { // 洗防資料重送
      this.showMoneyLaund = true
      // this.showMoneyLaundInsureNo = item.insureNo
      this.showMoneyLaundTransCode = item.transCode
      this.showMoneyLaundPolInsureType = item.polInsureType
      this.insStepHandler({ progClassName: 'proposal_moneyLaund', methodName: '洗防資料重送', stepCode: '', transCode: item.transCode })
    },
    //fix: SCR #89564 , 將 「EDD表單下載」  功能移除!
    // eddDownloadHandler (item) { // EDD表單下載
    //   let transCode = item.transCode
    //   let compCode = item.compCode
    //   const idStr = 'downloadEddDPdf_Link'
    //   let url = this.$api.defaults.baseURL +
    //   '/ins/common/insPolicies/downloadEDDPdf?transCode='+ transCode + '&compCode=' + compCode
    //   // 因為對於 Safari 瀏覽器，由於它不支持 download 屬性，改為在新的分頁中打開檔案
    //   if (this.$isSafari) {
    //     window.open(url, "_blank");
    //   } else {
    //     let link = null
    //     link = document.getElementById(idStr)
    //     if (!link) {
    //       link = document.createElement('a')
    //       link.id = idStr
    //       link.style.display = 'none'
    //       link.target = '_blank'
    //       document.body.appendChild(link)
    //     }
    //     link.href = url
    //     let fileName = '盡職調查問卷_' + transCode + '.pdf'
    //     link.setAttribute('download', fileName)
    //     this.startLoading()
    //     link.click()

    //     setTimeout(() => {
    //       this.endLoading()
    //       this.queryData(false)
    //     }, 1000)
    //   }
    //   this.insStepHandler({ progClassName: 'proposal_eddDownload', methodName: 'EDD表單下載', stepCode: '', transCode: item.transCode})

    // },
    writSendDateHandler (item) { // 回填寄件日期
      this.showWritSendDate = true
      this.writSendItem = item
      this.insStepHandler({ progClassName: 'proposal_writSendDate', methodName: '回填寄件日期(遠距)', stepCode: '', transCode: item.transCode})
    },
    writtenDownloadHandler (item) { // 書面分析下載
      let transCode = item.transCode
      let compCode = item.compCode
      const idStr = 'writtenDownload_Link'
      let url = this.$api.defaults.baseURL +
      '/ins/common/insPolicies/downloadWritten?insureNo='+ transCode + '&compCode=' + compCode
      // 因為對於 Safari 瀏覽器，由於它不支持 download 屬性，改為在新的分頁中打開檔案
      if (this.$isSafari) {
        window.open(url, "_blank");
      } else {
        let link = null
        link = document.getElementById(idStr)
        if (!link) {
          link = document.createElement('a')
          link.id = idStr
          link.style.display = 'none'
          link.target = '_blank'
          document.body.appendChild(link)
        }
        link.href = url
        let fileName = '書面分析資料_' + transCode + '.pdf'
        link.setAttribute('download', fileName)
        this.startLoading()
        link.click()

        setTimeout(() => {
          this.endLoading()
          this.queryData(false)
        }, 1000)
      }
      this.insStepHandler({ progClassName: 'proposal_writtenDownload', methodName: '書面分析下載(遠距)', stepCode: '', transCode: item.transCode})
    },
    writtenReSendHandler(item) { // 重寄書面分析
      const params = {
        transCode :item.transCode,
        oCusEmail :item.oCusEmail,
        oCusIdn: item.oCusIdn,
        oCusName: item.oCusName,
        userCode :item.userCode,
        insAcceptdt :item.insAcceptdt,
      }
      this.postReSendWritten(params)
      this.insStepHandler({ progClassName: 'proposal_writtenReSend', methodName: '重寄書面分析(遠距)', stepCode: '', transCode: item.transCode})
      this.$alert('已重寄書面分析資料')
    },

    interviewHandler (item) { // 展開回填電訪結果
      this.interviewItem = item
      this.showInterview = true
      this.insStepHandler({ progClassName: 'proposal_interview', methodName: '回填電訪結果', stepCode: '', transCode: item.transCode})
    },
    showPreViewPDFHandler (item) { // 展開 完成凱壽APP後檢視
      // 資料來源
      this.fetchInsPoliciesRecords({
          transCode: item.transCode,
          annexCodeList: ['A01', 'B03', 'B05', 'B02'],
          compCode: item.compCode
        }).then(r => {
          let annexItem = groupBy(r.data, 'docCode')
          this.$set( this.preViewPdfItem, 'annexItem', annexItem)
          this.fetchInsPoliciesPolf({
            transCode: item.transCode,
            fileType: ['A', 'B', 'C']
          }).then(r => {
            this.$set( this.preViewPdfItem, 'polfItem', r.data)
            this.showPreViewPDF = true
            this.polInsureType = item.polInsureType
          })
        })

    },
    checkEndDateValid () {
      return Date.parse(this.endDate) >= Date.parse(this.startDate)
    },
    queryDataCheck () { // 查詢
      this.checkUiVer().then(r => {
        if (!r) {
          // 版號有異動
          this.$alert('版號有異動，重新載入!', yn => {
            window.location.reload()
          })
        } else {
          localStorage.removeItem('aTransCode')
          this.transCode = ''
          this.queryData(true)
        }
      })
    },
    queryData (savelog) { // 查詢
      let isEndDateValid = true
      if (this.startDate !== null && this.endDate !== null) {
        isEndDateValid = this.checkEndDateValid()
      }
      if (
        (this.startDate !== null && this.endDate === null) ||
        (this.startDate === null && this.endDate !== null)
      ) {
        this.showSearchResult = false
        this.$alert('最後異動日期起迄日皆需輸入')
      } else if (!isEndDateValid) {
        this.showSearchResult = false
        this.$alert('最後異動日期迄日不可小於起日')
      } else {
        this.showSearchResult = true
        let userInfo = this.$store.getters['user/info']
        this.carryYn = userInfo.carryYn
        this.fetchInsPolicies({
          transCode:this.transCode,
          oCusName: this.oCusName, // 要保人
          iCusName: this.iCusName, // 被保險人
          proName: this.proName, // 主約商品名稱
          polState: this.polState, // 要保書處理進度代碼
          carryYN: userInfo.carryYn, // 是否為攜出裝置
          modifyDtStart: this.startDate, // 最後異動日期-起
          modifyDtEnd: this.endDate, // 最後異動日期-迄
          polInsureType: this.polInsureType, // 案件類型
          progClassName: 'proposal_search',
          methodName: '要保書查詢'
        }).then(r => {
          if (r.data.length > 0) {
            this.searchResult = r.data
          } else {
            this.$alert('查無資料!')
            this.searchResult = []
          }
          if (savelog) {
            this.insStepHandler({ progClassName: 'proposal_search', methodName: '要保書查詢', stepCode: ''})
          }
        })
      }
    },
    headerHandler (column) { // 排序
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    clearAll (boolean) { // 清除全部
      this.iCusName = null
      this.oCusName = null
      this.startDate = null
      this.endDate = null
      this.proName = null
      this.polState = null
      this.polInsureType = null
      if (boolean) {
        this.insStepHandler({ progClassName: 'proposal_clear', methodName: '全部清除', stepCode: '', transCode: ''})
      }
    },
    insStepHandler ({
      progClassName,
      methodName,
      stepCode,
      actionMsg,
      transCode
    }) {
      this.$store.dispatch('common/postUserAccessLog', {
          transCode: transCode,
          actionMsg: actionMsg,
          progClassName: progClassName,
          methodName: methodName,
          sysType: 'F',
          stepCode: stepCode
        })
        .then(r => {})
    },
    startLoading () {
      this.$store.commit('START')
    },
    endLoading () {
      this.$store.commit('END')
    },
    closeChoosePolTypeDialog () { //選擇要保書案件類型 關閉視窗
      this.insStepHandler({ progClassName: 'choosePolType_close', methodName: '取消選擇要保書案件類型', stepCode: this.tabStep })
      this.showPolType = false
    },
    closePreViewPDFResultDialog () { // 轉跳凱壽前檢視 關閉視窗
      this.showPreViewPDF = false
      this.polInsureType = null
    },
    closeInterviewResultDialog (item) { // 回填電訪結果  關閉視窗
      this.insStepHandler({ progClassName: 'commitInterview_close', methodName: '取消(回填電訪結果)', stepCode: this.tabStep, transCode: item.transCode })
      this.showInterview = false
    },
    closeCheckItemDialog (item) { // 檢核資料重送  關閉視窗
      this.insStepHandler({ progClassName: 'searchPageCheckItem_close', methodName: '取消選擇要保書案件類型', stepCode: this.tabStep, transCode: this.transCode })
      this.showCheckItem = false
    },
    closewWritSendDateDialog (item) { // 回填寄件日期 關閉視窗
      this.insStepHandler({ progClassName: 'writSendDate_close', methodName: '取消回填寄件日期', stepCode: this.tabStep, transCode: item.transCode })
      this.showWritSendDate = false
    },
    commitInterviewResult (params) { // 回填電訪 視窗 結果送出
      this.$confirm(
        "電訪結果儲存後不可再編輯，是否確認 ?"
        ).then( yn => {
          if (yn) {
            this.postInterViewResult(params).then(r => {
              this.showInterview = false
              this.queryData(false)
              this.insStepHandler({ progClassName: 'commitInterview_save', methodName: '儲存(回填電訪結果)', stepCode: this.tabStep })
            })
          }
        })
    },
    commitwWritSendDate (params) { // 回填寄件日期 視窗 結果送出
      this.$confirm(
        "寄送日期儲存後不可再編輯，是否確認 ?"
        ).then( yn => {
          if (yn) {
            this.postWritSendDate(params).then(r => {
              this.showWritSendDate = false
              this.queryData(false)
              this.insStepHandler({ progClassName: 'writSendDate_save', methodName: '儲存(回填寄件日期)', stepCode: this.tabStep, transCode: params.transCode })
            })
          }
        })
    },
    checkItemPropAudit() { //檢核資料重送 視窗 送審 外層元件
      this.$refs['checkItemDialogRef'].audit()
    },
    checkItemPropTempSave () { // 檢核資料重送 視窗 暫存 外層元件
      this.insStepHandler({ progClassName: 'searchPageCheckItem_tempSave', methodName: '暫存(檢核資料重送)', stepCode: this.tabStep,transCode: this.transCode })
      this.$refs['checkItemDialogRef'].searchPageTempSave()
    },
    checkItemAudit(result) { //檢核資料重送 視窗 送審
      this.$set(result, 'executeFrom', 'audit')
      this.postCheckItem(result).then(r => {
        if (r.data != '') {
          this.$alert(r.data) //發生錯誤
        } else {
          this.$alert('送審完成', (yn) => {
            this.queryData(false)
            this.insStepHandler({ progClassName: 'searchPageCheckItem_audit', methodName: '送審(檢核資料重送)', stepCode: this.tabStep,transCode: this.transCode })
            this.showCheckItem = false
          })
        }
      })
    },
      checkItemTempSave (result) { // 檢核資料重送 視窗 暫存
        this.$set(result, 'executeFrom', 'searchPageTempSave')
        this.postCheckItem(result).then(r => {
          this.$alert('暫存完成', (yn) => {
              this.queryData(false)
              this.showCheckItem = false
            })
          // this.queryData()
        })
      // let vm = this
      // let cusFrom = vm.getCusInfoData()
      // vm.postCusInfo(cusFrom).then(() => {
      //   vm.$alert('暫存成功')
      // })
    },
    filePickerLog () {
      this.insStepHandler({ progClassName: 'searchPageCheckItem_filePicker', methodName: '選擇檔案(檢核資料重送)', stepCode: this.tabStep,transCode: this.transCode  })
    },
    onUpload (updFileObj) { // 上傳檔案至DB儲存
      const { checkItemFileList } = this
      let fileArray =  filter(checkItemFileList, function(f) { // 取得該列別已上傳檔案數
        return f.fileType == updFileObj.fileType
      })
      let fileSize = fileArray.length ? fileArray.length : 0
      if (this.insFileLimit <= fileSize) {
        this.$alert('已超過上傳檔案數量限制: ' + this.insFileLimit)
      } else if (updFileObj && updFileObj.files && updFileObj.fileType) {
          const opt = {
          files: updFileObj.files,
          fileName: updFileObj.fileName,
          base64Str: updFileObj.base64Str,
          fileType: updFileObj.fileType,
          stepCode: this.stepCode,
          transCode: this.transCode
        }
        this.postUpdFileBase64(opt).then(r => {
          this.insStepHandler({ progClassName: 'searchPageCheckItem_upload', methodName: '上傳(檢核資料重送)', stepCode: this.tabStep,transCode: this.transCode })
          this.fetchInsPoliciesPolf({ // 重取檔案列表
            transCode: this.transCode,
            fileGroup: ['VALIDATE']
          }).then(r => {
              this.checkItemFileList = r.data
          })
        })
      }
    },
    onDelete (fileCode) { // 刪除
      if (fileCode && fileCode.length) {
        const opt = {
          fileCode: fileCode,
          stepCode: this.stepCode,
          transCode: this.transCode
        }
        this.delFile(opt).then(r => {
          this.fetchInsPoliciesPolf({ // 重取檔案列表
            transCode: this.transCode,
            fileGroup: ['VALIDATE']
          }).then(r => {
              this.checkItemFileList = r.data
          })
        })
      }
    },
    setMoneyLaundConfirmFlag (flag) {
      this.moneyLaundConfirmFlag = flag
    },
    moneyLaundAudit () {
      const callback = () => {
        this.showMoneyLaund = false
        this.showMoneyLaundTransCode = ''
        this.showMoneyLaundPolInsureType = ''
      }
      this.$refs['refAgentfiles'].nextStepHandler(callback)
    },
    closeMoneyLaundDialog () { // 關閉視窗
      this.insStepHandler({ progClassName: 'searchPageMoneyLaund_close', methodName: '取消', stepCode: this.tabStep, transCode: this.showMoneyLaundTransCode })
      this.showMoneyLaund = false
      this.showMoneyLaundTransCode = ''
      this.showMoneyLaundPolInsureType = ''
    },
    stateMsg (returnDesc) {
      this.$alert('退件原因： ' + returnDesc)
    },
    proposalDialogSignatureClose(){//簽名功能獨立畫面關閉
      this.showProposalDialogSignature = false
    }
  },
  created () {
    this.fetchAllAdmCodeDetail()
    this.fetchAllSystemParam()
    this.$api
      .get('/adm/com/inWorkTimInterval')
      .then(r => {
        if (r.data !== 'Y') {
          this.$alert('所選擇之功能目前時段不開放始用')
          this.$router.replace('home')
        } else {
          this.init()
        }
      })
    this.isAppDev = (process.env.VUE_APP_DEV_ENV === 'development') || (process.env.NODE_ENV === 'development')
  }
}
</script>
<style lang="stylus">
.date-picker-input {
  .v-text-field__prefix {
    margin-top: 0px !important;
  }
}

.date-picker-input.v-text-field--outline .v-input__control .v-input__slot {
  padding-right: 0px !important;
}
</style>
